import { useQuery } from '@tanstack/react-query';
import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useFetch } from '@/hooks/useFetch';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import type { GetImportantDatesResponse } from '@/types/clientDetailsApiTypes';

export const IMPORTANT_DATES_QUERY_KEY = 'important-dates';

export const useGetImportantDates = (clientId?: string | number) => {
  const [searchQuery] = useSearchQuery();
  const clientIdFromQuery = searchQuery.get(CLIENT_ID_QUERY_KEY);
  const id = clientId || clientIdFromQuery;

  const { doFetch: getImportantDates } = useFetch<void, GetImportantDatesResponse>();

  const query = useQuery({
    queryKey: [IMPORTANT_DATES_QUERY_KEY, id],
    queryFn: async () => {
      const response = await getImportantDates(`/api/important-dates/client/${id}`);
      return response;
    },
    enabled: !!id,
  });

  return query;
};